
// API Root Endpoint
// DEV
// export const api = 'http://localhost:8080/'
// PROD
export const api = 'http://192.81.129.36:8080/'

export const baseurl = 'http://webhipromeasa.com/'

export default api



// WEBPACK FOOTER //
// ./src/api/ApiConst.js